export const IC_MAINNET_URLS = ['https://mainnet.dfinity.network', 'ic0.app'];
